<template>
  <div>
    <portal to="tabs">
      <v-tabs v-model="tabIndex" background-color="transparent">
        <v-tab v-for="(tab,idx) in localTabs" :key="idx" @click="localTabSelected = tab.name;tab?.path&&$router.push(tab.path)">
          <v-icon v-if="tab?.icon" class="pr-2">{{tab.icon}}</v-icon>
          <span class="text-no-wrap">{{tab.label}}</span>
          <v-badge v-if="$tools.isDefined(tab.count)" class="ml-1" :content="tab.count" color="green" inline/>
        </v-tab>
      </v-tabs>
    </portal>
    <div>
      <slot name="default" v-bind:tabSelected="localTabSelected"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tabs','tabSelected'],
  data:()=>({
    tabIndex:null,
    localTabs: [],
    localTabSelected:null,
  }),
  mounted(){
    this.tabSelectedLoad();


    

    //   this.localTabSelected=this.tabSelected
    //   this.tabIndex = this.localTabs.findIndex(tab => tab.name === this.localTabSelected);
    // }  
  
    // setTimeout(()=>{
    
    //     this.localTabSelected=this.tabSelected
    //         console.log(this.localTabs)
    //     this.tabIndex = this.localTabs.findIndex(tab => tab.name === this.localTabSelected);


    // },5000)
  },
  watch:{
    '$route': {
      handler: function () {
        this.tabSelectedLoad();
      },
      immediate: true
    },
    localTabSelected(){
      this.$emit('update:tabSelected',this.localTabSelected)
    },
    tabSelected(v) {
      this.$nextTick(() => {
          if(v) {
            this.localTabSelected=v
            this.tabIndex = this.localTabs.findIndex(tab => tab.name === this.localTabSelected);
            if(this.tabIndex===-1) {
              if(this.localTabs.length>0) {
                this.localTabSelected = this.localTabs[0].name
                this.tabIndex = 0;
              }
            }          
          }
      });
    }
  },
  methods:{
    tabSelectedLoad(){
      const checkedTabs = this.$tabPermsCheck(this.tabs);
      this.localTabs = checkedTabs?.tabs||[];
      this.localTabSelected = checkedTabs?.tabSelected||null;
      this.tabIndex = this.localTabs.findIndex(tab => tab.name === this.localTabSelected);
    }
  }
}
</script>
